module.exports = __webpack_public_path__ + "static/media/14UNEP25.e2e3d42f.jpg";